<div [formGroup]="parentFormGroup" class="form-container">
  <mat-form-field appearance="outline" class="form-date">
    <mat-label i18n>End date</mat-label>
    <input matInput [matDatepicker]="bookingDateEnd" id="booking-date-end-date" formControlName="endDate">
    <mat-datepicker-toggle matSuffix [for]="bookingDateEnd"></mat-datepicker-toggle>
    <mat-datepicker [startAt]="startAt" #bookingDateEnd></mat-datepicker>
  </mat-form-field>

  <mat-form-field appearance="outline" class="form-hour">
    <mat-label i18n>Hour</mat-label>
    <mat-select id="booking-date-end-hour" formControlName="endHour">
      @for (option of hourNames; track option) {
        <mat-option [value]="option.id">
          {{ option.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="form-minute">
    <mat-label i18n>Minute</mat-label>
    <mat-select id="booking-date-end-minute" formControlName="endMinute">
      @for (option of minuteNames; track option) {
        <mat-option [value]="option.id">
          {{ option.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
